var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptySearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 81,
    viewBox: "0 0 109 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.85 26C85.26 26 93.698 34.434 93.698 44.838C93.698 49.111 92.275 53.051 89.878 56.211L107.827 74.161C109.391 75.726 109.391 78.262 107.827 79.827C106.262 81.391 103.726 81.391 102.162 79.827L83.772 61.437C81.115 62.866 78.077 63.677 74.849 63.677C64.44 63.677 56 55.242 56 44.838C56 34.434 64.44 26 74.85 26Z",
    fill: "#E9E9F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92 0H4C1.79086 0 0 1.79086 0 4V15C0 17.2091 1.79086 19 4 19H92C94.2091 19 96 17.2091 96 15V4C96 1.79086 94.2091 0 92 0Z",
    fill: "#E9E9F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44 27H4C1.79086 27 0 28.7909 0 31V42C0 44.2091 1.79086 46 4 46H44C46.2091 46 48 44.2091 48 42V31C48 28.7909 46.2091 27 44 27Z",
    fill: "#E9E9F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47 54H4C1.79086 54 0 55.7909 0 58V69C0 71.2091 1.79086 73 4 73H47C49.2091 73 51 71.2091 51 69V58C51 55.7909 49.2091 54 47 54Z",
    fill: "#E9E9F0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySearch);
export default __webpack_public_path__ + "static/media/empty-search.cb158536.svg";
export { ForwardRef as ReactComponent };